import { combineReducers } from 'redux';

// ================== Reducers ================== //
import profile from 'products/nomad_insurance/views/Profile/reducer';
import purchaseInsurance from 'products/nomad_insurance/views/Purchase/reducer';
import hospitalSearch from 'products/nomad_insurance/views/HospitalSearch/state';
import claims from 'products/nomad_insurance/views/ClaimsForm/state';
import planholder from './planholder';
import contract from './contract';
import groupMembers from './groupMembers';
import countries from './countries';
import offers from './offers';
import application from './application';
import referrals from './referrals';
import vouchers from './vouchers';
import credit from './credit';

const nomadInsuranceReducer = combineReducers({
  planholder,
  contract,
  hospitalSearch,
  profile,
  purchaseInsurance,
  groupMembers,
  claims,
  countries,
  offers,
  application,
  referrals,
  vouchers,
  credit
});

export default nomadInsuranceReducer;
